export default __webpack_public_path__ + "static/media/acceleY.81c9542b.svg";